import React from "react";

import Tree from "./Tree";

const ERROR_BOX = "tw-mx-2 tw-mb-3 tw-p-3 tw-rounded-[var(--cf-radius-sm)] tw-border tw-border-[color:var(--cf-color-error-border)] tw-bg-[color:var(--cf-color-error-bg)] tw-text-[color:var(--cf-color-error-text)]";
const STATE_TEXT = "tw-m-0 tw-px-3 tw-py-2 tw-text-[color:var(--cf-color-text-muted)] tw-text-lg";
const SEARCH_BTN_BASE = "tw-flex tw-items-center tw-gap-2 tw-w-full tw-min-w-0 tw-border-0 tw-bg-transparent tw-text-left tw-pl-[30px] tw-pr-2.5 tw-py-2 tw-rounded-[var(--cf-radius-sm)] tw-text-[14px] tw-font-semibold tw-text-[color:var(--cf-color-text-secondary)] hover:tw-bg-[color:var(--cf-color-surface-hover)]";
const SEARCH_BTN_ACTIVE = "tw-bg-[color:var(--cf-color-accent-soft)] !tw-text-[color:var(--cf-color-accent)]";
const ITEM_ICON = "tw-shrink-0 -tw-ml-0.5 tw-w-[18px] tw-text-[15px] tw-text-[color:var(--cf-color-text-muted-dark)]";
const LABEL = "tw-min-w-0 tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap";

const Sidebar = ({
    searchTerm,
    onSearchTermChange,
    treeError,
    searchError,
    searchLoading,
    searchResults,
    treeLoading,
    contentTree,
    expandedFolders,
    selectedPageId,
    onToggleFolder,
    onSelectPage
}) => {
    const isSearching = Boolean(searchTerm.trim());

    return (
        <aside className="confluence-help__sidebar  tw-w-[344px] max-lg:tw-w-full tw-shrink-0 tw-bg-[color:var(--cf-color-surface-subtle)] tw-border-r tw-border-[color:var(--cf-color-border)] tw-px-3 tw-pt-4 tw-pb-5 tw-overflow-y-auto">
            <div className="tw-relative tw-mb-3.5">
                <span className="fa fa-search tw-absolute tw-top-1/2 tw-left-3.5 -tw-translate-y-1/2 tw-text-[15px] tw-text-[color:var(--cf-color-text-subtle)]" />
                <input
                    className="confluence-help__search-input tw-w-full tw-h-11 tw-pl-10 tw-pr-10 tw-rounded-[var(--cf-radius-md)] tw-border tw-border-[color:var(--cf-color-border-strong)] tw-bg-white tw-text-[15px] tw-text-[color:var(--cf-color-text-primary)] tw-outline-none"
                    onChange={(event) => onSearchTermChange(event.target.value)}
                    placeholder="Suche..."
                    type="text"
                    value={searchTerm}
                />
                {searchTerm ? (
                    <button
                        aria-label="Suche zurücksetzen"
                        className="tw-absolute tw-top-1/2 tw-right-2 -tw-translate-y-1/2 tw-inline-flex tw-items-center tw-justify-center tw-w-7 tw-h-7 tw-rounded-full tw-border-0 tw-bg-transparent tw-text-[14px] tw-text-[color:var(--cf-color-text-subtle)] tw-cursor-pointer hover:tw-bg-[color:var(--cf-color-surface-hover)] hover:tw-text-[color:var(--cf-color-text-primary)] focus:tw-outline-none focus:tw-bg-[color:var(--cf-color-surface-hover)]"
                        onClick={() => onSearchTermChange("")}
                        title="Suche zurücksetzen"
                        type="button"
                    >
                        <span className="fa fa-times" />
                    </button>
                ) : null}
            </div>

            {treeError ? <div className={ERROR_BOX}>{treeError}</div> : null}
            {searchError ? <div className={ERROR_BOX}>{searchError}</div> : null}

            {isSearching ? (
                searchLoading ? (
                    <div className="tw-flex tw-justify-center tw-items-center tw-mt-6">
                        <div class="loading-overlay-progress-icon">
                            <i className="fa fa-spinner fa-pulse fa-fw tw-text-[20px]" ></i>
                        </div>
                    </div>
                ) : searchResults.length > 0 ? (
                    <ul className="tw-list-none tw-m-0 tw-p-0">
                        {searchResults.map((item) => (
                            <li className="tw-m-0" key={item.id}>
                                <button
                                    className={`${SEARCH_BTN_BASE}${selectedPageId === item.id ? ` ${SEARCH_BTN_ACTIVE}` : ""}`}
                                    onClick={() => onSelectPage(item.id)}
                                    type="button"
                                >
                                    <span className={`${ITEM_ICON} fa fa-file-text-o`} />
                                    <span className={LABEL}>{item.title}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className={STATE_TEXT}>Es wurden keine passenden Artikel gefunden.</p>
                )
            ) : treeLoading ? (
                <p className={STATE_TEXT}>Artikel werden geladen...</p>
            ) : (
                <Tree
                    expandedFolders={expandedFolders}
                    items={contentTree}
                    onSelectPage={onSelectPage}
                    onToggleFolder={onToggleFolder}
                    selectedPageId={selectedPageId}
                />
            )}
        </aside>
    );
};

export default Sidebar;
